import CategoryDropdown from '@/Components/inputs/CategoryDropdown';
import React, { useCallback } from 'react';
import { z } from 'zod';
import { FilterBadge } from '../components/FilterBadge';
import { __useFilterState } from '../useFilterState';

const categorySearchSchema = z.object({
  category: z.array(z.string()).nullish(),
});

const categoryComponentProps = z.object({
  displayName: z.string().optional(),
});

type CategoryFilterProps = z.infer<typeof categoryComponentProps>;

const CategoryFilter = ({ displayName = 'Category' }: CategoryFilterProps) => {
  const { fastFilters, updateFilter, isUpdating } = __useFilterState(categorySearchSchema);

  const handleCategoriesChange = useCallback(
    (categories: string[]) => {
      updateFilter({
        category: categories.length ? categories : undefined,
      });
    },
    [updateFilter]
  );

  return (
    <div style={{ position: 'relative' }}>
      <CategoryDropdown
        selectedCategories={fastFilters.category || []}
        onCategoriesChange={handleCategoriesChange}
        displayName={displayName}
      />
      <FilterBadge count={fastFilters.category?.length || 0} isUpdating={isUpdating} />
    </div>
  );
};

const CategoryFilterMemo = React.memo(CategoryFilter);

export const FilterConfig_Category = {
  category: {
    searchSchema: categorySearchSchema,
    component: CategoryFilterMemo,
    componentProps: categoryComponentProps,
  },
} as const;
